import { TimeMaterialRMAId } from './../../entities/tm/TimeMaterialRMAResponse';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { CompactTimeMaterialRMAResponse, TimeMaterialRMAResponse } from '@business/entities/tm/TimeMaterialRMAResponse';
import { TimeMaterialId } from '@business/entities/tm';
import { TimeMaterialRMAAPI } from '@business/api/timeMaterialRma';

export class TmRMABloc extends BaseBloc {
  private readonly tmRmaRepo = new Repository<CompactTimeMaterialRMAResponse | TimeMaterialRMAResponse>({
    getItemId: item => item.id,
  });

  readonly items$ = this.tmRmaRepo.items$;
  readonly selectItem = this.tmRmaRepo.selectItem;

  onReset() {
    this.tmRmaRepo.reset();
  }

  fetchItems = (id: TimeMaterialId) => {
    return TimeMaterialRMAAPI.fetchItems(id).pipe(this.tmRmaRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_rma_error') }));
  };

  fetchItem = (id: TimeMaterialRMAId) => {
    return TimeMaterialRMAAPI.fetchItem(id).pipe(
      this.tmRmaRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_rma_error') }),
    );
  };

  createItem = (timeMaterialId: TimeMaterialId, data: Partial<CompactTimeMaterialRMAResponse>) => {
    return TimeMaterialRMAAPI.createItem(timeMaterialId, data).pipe(
      this.tmRmaRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_rma_phase'),
      }),
    );
  };

  updateItem = (id: TimeMaterialRMAId, data: Partial<CompactTimeMaterialRMAResponse>) => {
    return TimeMaterialRMAAPI.updateItem(id, data).pipe(
      this.tmRmaRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_rma_phase'),
      }),
    );
  };

  deleteItem = (id: TimeMaterialRMAId) => {
    return showDeleteConfirmation('Delete RMA', 'Do you really want to remove this RMA?').pipe(
      switchMap(() => TimeMaterialRMAAPI.deleteItem(id)),
      this.tmRmaRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_rma_phase'),
      }),
    );
  };
}
